import * as React from 'react'
import { Alert, AlertDescription } from '../ui/alert'
import { AlertTriangleIcon } from 'lucide-react'

interface IProps {
	message?: string
	type?: string
}

export default function FlashAlert({ message, type }: IProps) {
	if (!message) return null

	const isError = type === 'alert' || type === 'error'

	return (
		<Alert className="max-w-md border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-50">
			<AlertTriangleIcon />
			<AlertDescription>{message}</AlertDescription>
		</Alert>
	)
}
